import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { SearchMenuHelper } from "@/Common/Helpers/SearchMenuHelper";
import { ThirdPartySyncStatus } from "@/Common/Models/ThirdPartySyncStatus";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { ThirdPartySyncDisplayState } from "../Models/ThirdPartySyncDisplayState";

class CalendaHelper {
    public static GetEmployeesBasedOnSitesAndQuery(q: string): Immutable.List<EmployeeUIModel> {
        var cliniciansFromSites: Immutable.List<EmployeeUIModel> = CalendaHelper.GetEmployeesFromSelectedSites();
        var filterString = q.trim();
        if (filterString !== "") { cliniciansFromSites = SearchMenuHelper.FilterCliniciansByName(filterString, cliniciansFromSites); }

        return cliniciansFromSites;
    }

    private static GetEmployeesFromSelectedSites(): Immutable.List<EmployeeUIModel> {
        var checkedSiteList = calendarStore.calendarDisplaySettingsModel.get("Sites").filter(s => s.Checked === true).map(s => s.Id).toArray();
        var allClinicians = calendarStore.calendarDisplaySettingsModel.get("EmployeesGlobalCache");
        return SearchMenuHelper.FilterCliniciansMembersOfSites(allClinicians, checkedSiteList);
    }

    public static GetThirdPartySyncDisplayState(status: ThirdPartySyncStatus, thirdPartyStatusLastUpdateDate: Date, appointmentLastUpdateDate: Date): ThirdPartySyncDisplayState {
        switch (status) {
            case ThirdPartySyncStatus.Synchronized:
                return MyleHelper.GetTimezoneAgnosticDatetimeFormat(thirdPartyStatusLastUpdateDate) >= MyleHelper.GetTimezoneAgnosticDatetimeFormat(appointmentLastUpdateDate)
                    ? ThirdPartySyncDisplayState.Green
                    : ThirdPartySyncDisplayState.Yellow;

            case ThirdPartySyncStatus.ResynchronizationNeeded:
            case ThirdPartySyncStatus.SynchronizationError:
            case ThirdPartySyncStatus.NotSynchronized:
            default:
                return ThirdPartySyncDisplayState.None;
        }
    }
}

export { CalendaHelper };
